import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsComponent } from '@sml/icons';
import { RadioButtonComponent } from '@sml/radio-button';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CampaignAccessLevelEnum, ITEM_STATUS_TYPE, POST_ITEM_SUBHEADINGS, POST_ITEM_TYPE, TooltipDirective } from '@sml/utility';
import { ToggleRadioButtonComponent } from '@sml/toggle-radio-button';


@Component({
  selector: 'sml-item-visiblity',
  imports: [CommonModule, IconsComponent, RadioButtonComponent, ReactiveFormsModule, ToggleRadioButtonComponent, TooltipDirective],
  templateUrl: './item-visiblity.component.html',
  styleUrl: './item-visiblity.component.scss',
})
export class ItemVisiblityComponent {
  iconNameVisiblity = [
    { name: 'lock' },
    { name: 'public-eye' },
  ];
    @Input() form!: FormGroup;
    @Input() accessType!:number | undefined;
    campaignAccessType=CampaignAccessLevelEnum;
    public itemPostType = POST_ITEM_TYPE;
    public itemPostSubHeadings = POST_ITEM_SUBHEADINGS;
  
    get control() {
      return this.form.controls;
    }
}
